import React from 'react';
import MacbookPro from '../../content/images/macbook-pro-m2.png';
import { isImage } from '../utils';

const LaptopMockup = ({ screenImg, backGroundColor='black' }) => {

  return (
    <div className='relative w-full h-full'>
      <div className='absolute w-full h-full' style={{paddingRight: '10.5%', paddingLeft: '10.5%', paddingTop: '1%', paddingBottom: '1%'}} >
        {
          isImage(screenImg) ?
          <img src={screenImg} className='h-full w-full object-contain object-top' style={{backgroundColor: backGroundColor, paddingTop: '1.5%'}}/>
          :
          <video
            src={screenImg}
            // alt={`Video ${idx + 1}`}
            className='h-full w-full object-contain object-top' 
            style={{backgroundColor: backGroundColor, paddingTop: '2.5%'}}
            autoPlay
            loop
            muted
            controls={false}
            playsInline
          />
        }
      </div>
      <img src={MacbookPro} className='relative z-10'/>
    </div> 
  )
};

export default LaptopMockup;


